import React from 'react'

const PhilippinesReq = () => {
  return (
    <div>
      
    </div>
  )
}

export default PhilippinesReq
